import type { Checkbox } from "radix-ui"

export type CheckboxCheckedState = Checkbox.CheckedState
